import { useIsOwner } from '@platewell/query';
import { useNavigate } from '@tanstack/react-router';

/**
 * The loudest state in the app: payment failed and the 3-day grace period ran out.
 *
 * It replaces the router outlet entirely rather than sitting above it, because every
 * mutating operation in `packages/core` throws while locked and a half-usable app would
 * just produce errors at every turn. Nothing has been deleted, and saying so plainly is
 * the most important line on the screen.
 */
export function LockScreen() {
  const isOwner = useIsOwner();
  const navigate = useNavigate();

  return (
    <div className="boot">
      <div className="empty">
        <h2>Your subscription payment didn’t go through.</h2>
        <p className="hint">
          Platewell is locked until the payment goes through. Nothing has been deleted — your
          recipes are safe and will be right here.
        </p>
        {/* Fixing the card on the same subscription, not buying again: the provider is
            still retrying it, and a second purchase would charge twice. */}
        {isOwner ? (
          <button className="btn primary" onClick={() => void navigate({ to: '/subscribe' })}>
            Update payment method
          </button>
        ) : (
          <p className="hint">Ask an owner of this household to update the payment method.</p>
        )}
      </div>
    </div>
  );
}
